import * as React from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';

import { Typography, withStyles, WithStyles } from '@nelnet/unifi-components-react';

import UsageNotification from '../UsageNotification';
import TwoColumn from '../TwoColumn';
import styles from '../Usage/styles';

interface IUsageProps extends WithStyles<typeof styles> {
  item_uid?: string;
  item_description?: RichTextBlock[];
  main_content_items?: RichTextBlock[];
  primary_usage_items?: RichTextBlock[];
  usage_notification_items?: RichTextBlock[];
}

const Usage: React.FunctionComponent<IUsageProps> = ({
  classes,
  item_uid,
  item_description,
  main_content_items,
  primary_usage_items,
  usage_notification_items,
}) => {
  return (
    <>
      <Typography variant="h3" className="regular" align="left" margin={{ top: 2 }}>
        Usage
      </Typography>
      <Typography variant="body1" align="left" margin={{ top: 2 }}>
        {RichText.asText(item_description)}
      </Typography>
      <div className={classes.paragraph} key={item_uid}>
        {RichText.render(main_content_items)}
      </div>
      {usage_notification_items ? (
        <UsageNotification usage_notification_items={usage_notification_items}></UsageNotification>
      ) : null}
      {primary_usage_items ? (
        <TwoColumn primary_usage_items={primary_usage_items}></TwoColumn>
      ) : null}
    </>
  );
};

export default withStyles(styles)(Usage);
